import NamedListPage from "@/features/org/components/NamedListPage";
import { branches } from "@/features/org/api/org.api";
import { FIELD_MAX } from "@/lib/fieldLimits";

export default function BranchesPage() {
  return (
    <NamedListPage
      api={branches}
      title="Branches"
      subtitle="Manage the branches / offices agents can belong to. These appear as suggestions on the user's Branch field."
      noun="branch"
      nameMax={FIELD_MAX.org.name}
      descMax={FIELD_MAX.org.description}
    />
  );
}
